// extracted by mini-css-extract-plugin
module.exports =  {"container":"_025a50318d--container--ktXmQ","link":"_025a50318d--link--acwir","link-area":"_025a50318d--link-area--bIF7s"};